import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';

function sleep(duration) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, duration);
  });
}

export default function Asynchronous({ label, lookupName, onChange }) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
    (async () => {
      setLoading(true);
      await sleep(1e3); // For demo purposes.
      setLoading(false);
      if(lookupName=='carModel'){
        setOptions([...carModel]);
      }
      else if(lookupName=='paymentMode'){
        setOptions([...paymentType]);
      }
      
    })();
  };

  const handleClose = () => {
    setOpen(false);
    setOptions([]);
  };

  const handleChange = (event, value) => {
    onChange(value); // Call onChange function with the selected value
  };

  return (
    <Autocomplete
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      onChange={handleChange} // Add this to capture changes
      isOptionEqualToValue={(option, value) => option.title === value.title}
      getOptionLabel={(option) => option.title}
      options={options}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            },
          }}
        />
      )}
    />
  );
}

// Sample data for demonstration
const carModel = [
  { title: 'INNOVA', year: 1994 },
  { title: 'ETIOS', year: 1972 },
  { title: 'ECCO', year: 1974 },
  { title: 'TRAVELLER', year: 1976 },
];


const paymentType = [
  { title: 'CARD', year: 1994 },
  { title: 'UPI', year: 1972 },
  { title: 'CASH', year: 1974 },
];